module.exports = __webpack_public_path__ + "static/media/photo218.73102ca7.jpg";